module.exports = __webpack_public_path__ + "assets/0786e1c201dd09832711e1428f55ca0d.png";